export function useGroups(hasGroup: (id: string) => boolean) {
    const cfg = useRuntimeConfig();
    const requiredGroups = (cfg.public.GROUPS || "")
        .split(",")
        .map(g => g.trim())
        .filter(Boolean);

    function isInAuthorizedGroup() {
        return !requiredGroups?.length || requiredGroups.some(id => hasGroup(id));
    }

    return { isInAuthorizedGroup };
}
